import { render, staticRenderFns } from "./OrdersEdit.vue?vue&type=template&id=4568d1a0&scoped=true&"
import script from "./OrdersEdit.vue?vue&type=script&lang=js&"
export * from "./OrdersEdit.vue?vue&type=script&lang=js&"
import style0 from "./OrdersEdit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrdersEdit.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./OrdersEdit.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./OrdersEdit.vue?vue&type=style&index=3&id=4568d1a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4568d1a0",
  null
  
)

export default component.exports